import axios from '@/plugins/axios';

export const requestRoot = '/api/customer-information-requests/';
export const receivedRoot = '/api/my-organization/customer-information-requests/';
export const profileRoot = '/api/my-organization/customer-information-profile/';
export function operationKey() {
    if (window.crypto?.randomUUID) return window.crypto.randomUUID();
    const bytes = window.crypto.getRandomValues(new Uint8Array(16));
    bytes[6] = (bytes[6] & 15) | 64;
    bytes[8] = (bytes[8] & 63) | 128;
    const hex = Array.from(bytes, x => x.toString(16).padStart(2, '0')).join('');
    return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}
export function sendOperation(url, data, key) {
    return axios.post(url, data, { headers: { 'Idempotency-Key': key } });
}
export function errorMessage(error) {
    const data = error.response?.data;
    const fields = (data?.field_errors || []).map(field => `${field.path} : ${field.message}`);
    return [data?.message || 'Cette action a échoué. Veuillez réessayer.', ...fields].join('\n');
}
export const addressFields = ['contact_name', 'line1', 'line2', 'postal_code', 'city', 'country', 'phone_number', 'mobile_phone_number'];
export const contactFields = ['civility', 'first_name', 'last_name', 'job_title', 'roles', 'email', 'phone_number', 'mobile_phone_number', 'is_primary', 'receives_documents', 'active'];
const pick = (value, fields) => Object.fromEntries(fields.map(field => [field, value[field]]));
export function writableProfile(profile) {
    return {
        identity: { ...profile.identity },
        billing_address: Object.fromEntries(addressFields.map(field => [field, profile.billing_address[field] || ''])),
        contacts: profile.contacts.filter(item => item.editable).map(item => ({ ...pick(item, contactFields), id: item.id || null, client_ref: item.client_ref || String(item.id) })),
        delivery_sites: profile.delivery_sites.filter(item => item.editable).map(item => ({ ...pick(item, ['name', 'emails', 'instructions', 'default', 'active', 'delivery_hours']), address: Object.fromEntries(addressFields.map(field => [field, item.address[field] || ''])), id: item.id || null, client_ref: item.client_ref || String(item.id) })),
    };
}
export function emptyAddress() { return Object.fromEntries(addressFields.map(field => [field, ''])); }
export function emptyContact() {
    return { id: null, client_ref: operationKey(), editable: true, civility: '', first_name: '', last_name: '', job_title: '', roles: [], email: '', phone_number: '', mobile_phone_number: '', is_primary: false, receives_documents: false, active: true };
}
export function emptySite() {
    return { id: null, client_ref: operationKey(), editable: true, name: '', emails: [], instructions: '', default: false, active: true, address: emptyAddress(), delivery_hours: { days: Array.from({ length: 7 }, (_, index) => ({ day: index + 1, mode: 'unknown', slots: [] })) } };
}

// Pending requests take priority over the age of the last confirmation.
export function informationTone({ loaded, error, pending, confirmedAt }, now = new Date()) {
    if (!loaded || error) return 'primary';
    if (pending && pending.email_status !== 'failed') return 'primary';
    if (!confirmedAt) return 'warning';
    const date = new Date(confirmedAt);
    if (Number.isNaN(date.getTime())) return 'warning';
    const freshCutoff = new Date(now);
    freshCutoff.setMonth(freshCutoff.getMonth() - 3);
    const overdueCutoff = new Date(now);
    overdueCutoff.setMonth(overdueCutoff.getMonth() - 6);
    if (date > freshCutoff) return 'success';
    return date <= overdueCutoff ? 'error' : 'warning';
}
